import { ModalActionTypes } from '../Modal/modal.actionTypes';


const initialState = {

  showLogin: false,
  showSignup: false
};


function modalReducer(state = initialState, { type, payload }) {


  switch (type) {
    case ModalActionTypes.SHOW_LOGIN:
      return {
        ...state,
        showLogin: true
      }
    case ModalActionTypes.HIDE_LOGIN:
      return {
        ...state,
        showLogin: false
      }
    case ModalActionTypes.SHOW_SIGNUP:
      return {
        ...state,
        showSignup: true
      }

    case ModalActionTypes.HIDE_SIGNUP:
      return {
        ...state,
        showSignup: false
      }

    default:
      return state;
  }

}

export default modalReducer;